import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {isEmpty, postSubmit, scrollToComponent} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {shareOfSearchKpiDetailsFilters} from "../@signals";
import {KEYWORD_TYPE} from "../@constants";


export default function useShareOfSearchKpiDetails() {
	const { showToast } = useAppToast()
	const detailsData = useSignal([])
	const detailsAggregation = useSignal([])
	const detailsKeywords = useSignal([])
	const detailsIsGenericType = useSignal(false)
	const isLoadingDetails = useSignal(false)

	useEffect(() => {
		if (isLoadingCommonFilters.value)
			detailsData.value = []
	}, [isLoadingCommonFilters.value])

	useEffect(() => {
		if (!isEmpty(shareOfSearchKpiDetailsFilters.value)) {
			isLoadingDetails.value = true
			postSubmit(`${WEBBACK_V2_API}/share-of-search/kpi/details-context`, {
				...commonFiltersValue.value,
				keywordType: KEYWORD_TYPE.KEYWORD,
				...shareOfSearchKpiDetailsFilters.value
			}).then(res => {
				detailsData.value = res.data
				detailsAggregation.value = res.aggregations
				detailsKeywords.value = res.keywords
				detailsIsGenericType.value = res.genericSplit
				isLoadingDetails.value = false
			}).catch(() => {
				showToast.error()
				shareOfSearchKpiDetailsFilters.value = {}
			}).finally(() => scrollToComponent('details-table'))
		}
		else batch(() => {
			detailsData.value = []
			detailsAggregation.value = []
			detailsKeywords.value = []
		})
	}, [JSON.stringify(shareOfSearchKpiDetailsFilters.value)]);

	return {
		detailsData: detailsData.value,
		detailsAggregation: detailsAggregation.value,
		detailsKeywords: detailsKeywords.value,
		detailsIsGenericType: detailsIsGenericType.value,
		isLoadingDetails: isLoadingDetails.value
	}

}